import _jsx from "@babel/runtime/helpers/jsx";
var _div, _div3, _Alert2, _span, _span2;
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Formsy
import { Form, Input, StandardEmailInput } from 'reaxl-forms';
import { Alert, Button, ColoredBackground, DisclaimerText, Image, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Popup, AnimatedButton } from 'reaxl';
import { subscribe } from 'axl-config';
const saveSearchImage = '/cm-api/content/static/img/icon/myatc/save-search-illustration.png';

/**
 *  EmailSubscribe
 *  Registers users for email alerts and prompt for full registration once limit is reached.
 */

/* TODO - connect saveSearch with component once stable*/
function EmailSubscribe(_ref) {
  var _div2, _Alert, _div4, _Button;
  let {
    className,
    email = '',
    emailSubscribeSend,
    onClose,
    onSignInClick = () => {},
    onSignInSave = () => {},
    onSignUpSave = () => {},
    onSubmit,
    onSubscribeUserStart = () => {},
    showEmailSubscribeModal,
    userDuck
  } = _ref;
  const dispatch = useDispatch();

  // Removed existing immutable state support as there is no usage that can be found
  // typeof state.toJS === 'function' ? state.get('user') : state.user || {};
  const user = useSelector(userDuck.selectors.getDuckState);
  const savedSearch = useSelector(userDuck.selectors.getSavedSearch);
  const subscribedSearch = useSelector(userDuck.selectors.getSubscribedSearch);
  // Removed as there is no usage seen
  // const personalizationAlert = useSelector(userDuck.selectors.getPersonalizationAlert);
  const {
    animatedButtonState
  } = useSelector(state => state.savedInventory) || {};
  const {
    showEmailSubscribeSuccess,
    showEmailSubscribeFailure,
    lightRegistrationError,
    emailAddress = email
  } = user;
  const showPrivacyStatement = !showEmailSubscribeSuccess;
  const getCallbacks = () => {
    const {
      onLogInSuccess = () => {},
      onSaveSuccess = () => {}
    } = subscribedSearch;
    return {
      onLogInSuccess: res => {
        onLogInSuccess(res, savedSearch);
      },
      onSaveSuccess: res => {
        onSaveSuccess(res, savedSearch);
      },
      onSubscribeUserStart: data => {
        onSubscribeUserStart(data);
      }
    };
  };
  const getPrivacyStatement = () => /*#__PURE__*/_jsx("span", {}, void 0, subscribe.privacyStatement.text, /*#__PURE__*/_jsx(Popup, {
    width: 600,
    height: 400,
    url: subscribe.privacyStatement.href
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "text-link margin-left-1"
  }, void 0, subscribe.privacyStatement.label)), ".");
  const handleRegister = data => {
    dispatch(userDuck.creators.registerEmailSubscribeUser({
      data: {
        email: data.emailAddress,
        search: subscribedSearch.saveSearchObject
      },
      ...getCallbacks()
    }));
    onSubmit(data, savedSearch);
  };
  const handleSignUpSave = useCallback(() => {
    onSignUpSave();
    onSignInClick();
  }, [onSignInClick, onSignUpSave]);
  const handleClose = () => {
    dispatch(userDuck.creators.hideEmailSubscribeModal());
    onClose();
  };
  const renderEmailSubscribeForm = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12 text-left display-flex"
  }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "margin-right-4 margin-bottom-3"
  }, void 0, /*#__PURE__*/_jsx(Image, {
    src: saveSearchImage,
    alt: ""
  }))), /*#__PURE__*/_jsx("div", {
    className: "text-bold text-size-400"
  }, void 0, subscribe.message))), /*#__PURE__*/_jsx(Form, {
    onValidSubmit: handleRegister,
    className: "margin-vertical-3"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
    className: "col-xs-7"
  }, void 0, /*#__PURE__*/_jsx(StandardEmailInput, {
    maxLength: "45",
    name: "emailAddress",
    label: "",
    required: true,
    placeholder: "Email",
    value: emailAddress
  }))), /*#__PURE__*/_jsx("div", {
    className: "col-xs-5"
  }, void 0, /*#__PURE__*/React.createElement(AnimatedButton, Object.assign({
    type: "submit",
    bsStyle: "default",
    block: true,
    formNoValidate: true
  }, emailSubscribeSend, {
    buttonText: "Subscribe",
    loadedText: "Subscribed",
    buttonState: animatedButtonState
  })))), lightRegistrationError && (_Alert || (_Alert = /*#__PURE__*/_jsx(Alert, {
    bsStyle: "danger"
  }, void 0, lightRegistrationError))), /*#__PURE__*/_jsx(Input, {
    type: "hidden",
    name: "textPot",
    id: "textPot",
    validations: {
      minLength: 0
    }
  })));
  const renderEmailSubscribeFailure = () => /*#__PURE__*/React.createElement(React.Fragment, null, _div3 || (_div3 = /*#__PURE__*/_jsx("div", {
    className: "display-flex"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "margin-auto padding-bottom-3"
  }, void 0, /*#__PURE__*/_jsx(Image, {
    src: saveSearchImage
  })))), _Alert2 || (_Alert2 = /*#__PURE__*/_jsx(Alert, {
    bsStyle: "warning"
  }, void 0, "You already have a maximum of 2 searches saved. To save this search, please create a free account.")), /*#__PURE__*/_jsx("div", {}, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "text-bold"
  }, void 0, "Create an account")), ' ', subscribe.inline.confirmation.signUp));
  const renderEmailSubscribeConfirmation = () => {
    if (showEmailSubscribeFailure) {
      return renderEmailSubscribeFailure();
    }
    return /*#__PURE__*/_jsx(Alert, {
      bsStyle: "success"
    }, void 0, _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
      className: "text-bold margin-right-2"
    }, void 0, "Thanks for subscribing!")), subscribe.confirmation.alert);
  };
  const getModalBody = () => {
    if (showEmailSubscribeSuccess || showEmailSubscribeFailure) {
      return renderEmailSubscribeConfirmation();
    }
    return renderEmailSubscribeForm();
  };
  const renderEmailSubscribeFailureFooter = () => _div4 || (_div4 = /*#__PURE__*/_jsx("div", {
    className: "margin-left-auto padding-4"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    className: "margin-right-4",
    onClick: handleClose,
    bsStyle: "text"
  }, void 0, "Cancel"), /*#__PURE__*/_jsx(Button, {
    type: "submit",
    bsStyle: "primary",
    onClick: handleSignUpSave
  }, void 0, "Create an Account")));
  const getModalFooter = () => {
    if (showEmailSubscribeFailure) {
      return renderEmailSubscribeFailureFooter();
    }
    return /*#__PURE__*/_jsx(ColoredBackground, {
      className: "padding-4"
    }, void 0, _Button || (_Button = /*#__PURE__*/_jsx(Button, {
      className: "margin-right-1",
      onClick: handleSignUpSave,
      bsStyle: "text"
    }, void 0, "Create an account")), subscribe.inline.confirmation.signUp);
  };
  return /*#__PURE__*/_jsx(Modal, {
    className: className,
    show: showEmailSubscribeModal,
    onHide: handleClose,
    bsSize: "small"
  }, void 0, /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, subscribe.title)), /*#__PURE__*/_jsx(ModalBody, {
    className: "padding-bottom-1"
  }, void 0, getModalBody(), showPrivacyStatement && !showEmailSubscribeFailure && /*#__PURE__*/_jsx(DisclaimerText, {
    size: 200,
    className: "text-left margin-bottom-4"
  }, void 0, getPrivacyStatement())), /*#__PURE__*/_jsx(ModalFooter, {
    className: "text-left display-flex padding-0"
  }, void 0, getModalFooter()));
}
export default /*#__PURE__*/React.memo(EmailSubscribe);